module.exports = __webpack_public_path__ + "img/Principal.867c74dd.jpeg";